/**
 * Loading spinner on native newsletter form submit.
 * Hooks: [data-newsletter-form] on the form, [data-newsletter-submit] on the button.
 */

const LOADING_RESET_MS = 10000;

function setSubmitLoading(button, isLoading) {
  if (!button) return;

  if (isLoading) {
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    return;
  }

  button.removeAttribute('aria-busy');
  button.disabled = false;
}

function bindNewsletterSubmit(form) {
  if (form.dataset.newsletterSubmitBound === 'true') return;
  form.dataset.newsletterSubmitBound = 'true';

  form.addEventListener('submit', function () {
    if (!form.checkValidity()) return;

    const button = form.querySelector('[data-newsletter-submit]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    setSubmitLoading(button, true);

    window.setTimeout(function () {
      if (button.getAttribute('aria-busy') === 'true') {
        setSubmitLoading(button, false);
      }
    }, LOADING_RESET_MS);
  });
}

function initNewsletterSubmitInRoot(root) {
  root.querySelectorAll('[data-newsletter-form]').forEach(bindNewsletterSubmit);
}

function initRelicNewsletterSubmit() {
  initNewsletterSubmitInRoot(document);
  document.addEventListener('shopify:section:load', function (event) {
    initNewsletterSubmitInRoot(event.target);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRelicNewsletterSubmit);
} else {
  initRelicNewsletterSubmit();
}
